<div class="esg-dialog-container">
  <app-titolo-subtitolo
    titolo="Esempi di documenti utili ai fini di rendicontazione ESG"
  ></app-titolo-subtitolo>

  <ng-scrollbar>
    <div class="dialog-content">
      <section class="doc-section">
        <h2 class="section-title">Documenti Generali</h2>
        <ul class="doc-list">
          @for (doc of documentiGenerali; track doc) {
            <li>{{ doc }}</li>
          }
        </ul>
      </section>

      <section class="doc-section">
        <h2 class="section-title">Documenti specifici</h2>

        <div class="iso-block">
          <h3>ISO 14001</h3>
          <ul class="iso-list">
            @for (item of iso14001; track item.code) {
              <li>
                <strong>{{ item.code }}</strong> {{ item.desc }}
              </li>
            }
          </ul>
        </div>

        <div class="iso-block">
          <h3>ISO 45001</h3>
          <ul class="iso-list">
            @for (item of iso45001; track item.code) {
              <li>
                <strong>{{ item.code }}</strong> {{ item.desc }}
              </li>
            }
          </ul>
        </div>
      </section>
    </div>
  </ng-scrollbar>
</div>
<div class="btn-chiudi">
  <button mat-dialog-close mat-flat-button color="accent" class="accent-button">Chiudi</button>
</div>
